export class BaseEntity {
    id: number | string;
}


// WEBPACK FOOTER //
// ./src/app/base/base.entity.ts